var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Spinner } from '../../ingredients/Spinner';
import { Typography } from '../../foundations/typography';
import styles from './ButtonBase.module.scss';
export var ButtonBaseComponent = function (_a, ref) {
    var _b;
    var component = _a.component, componentProps = _a.componentProps, children = _a.children, className = _a.className, disabled = _a.disabled, endIcon = _a.endIcon, label = _a.label, _c = _a.save, save = _c === void 0 ? false : _c, startIcon = _a.startIcon, _d = _a.success, success = _d === void 0 ? false : _d, _e = _a.theme, theme = _e === void 0 ? 'primary' : _e, _f = _a.waiting, waiting = _f === void 0 ? false : _f, _g = _a.width, width = _g === void 0 ? 'standard' : _g, _h = _a.small, small = _h === void 0 ? false : _h, rest = __rest(_a, ["component", "componentProps", "children", "className", "disabled", "endIcon", "label", "save", "startIcon", "success", "theme", "waiting", "width", "small"]);
    var Component = component || 'button';
    var buttonStyles = cx(styles.button, styles[theme], (_b = {},
        _b[styles.full] = width === 'full',
        _b[styles.fit] = width === 'fit',
        _b[styles.waiting] = waiting,
        _b[styles.success] = success,
        _b[styles.save] = save,
        _b[styles.small] = small,
        _b[styles.iconOnly] = (startIcon || endIcon) && !label && !children,
        _b), className);
    var labelStyles = cx({
        withStartIcon: startIcon,
        withEndIcon: endIcon,
    });
    var spinnerTheme = theme === 'secondary' || theme === 'primaryWhite' ? 'dark' : 'light';
    return (React.createElement(Component, __assign({ className: buttonStyles, disabled: disabled || waiting, ref: ref }, rest),
        waiting && (React.createElement("span", { className: styles.spinnerContainer },
            React.createElement(Spinner, { isActive: waiting, size: "small", theme: spinnerTheme }))),
        startIcon,
        (label || children) && (React.createElement(Typography, { element: "span", noMargins: true, styleAs: "paragraphHeading", className: labelStyles }, label || children)),
        endIcon));
};
export var ButtonBase = forwardRef(ButtonBaseComponent);
//# sourceMappingURL=ButtonBase.js.map